module.exports = __webpack_public_path__ + "img/Logo-white.837a22c0.svg";